import React from 'react';
import { UsersList } from '../../components/admin/UsersList';
import { useUsersList } from '../../hooks/useUsersList';

export const UsersListPage: React.FC = () => {
  const usersListProps = useUsersList();

  return <UsersList {...usersListProps} />;
};
